import React, { useState } from 'react';

import { PrimaryButtonV2 } from '@fragment/ui/src/components/Button/PrimaryButtonV2/PrimaryButtonV2';
import { SecondaryButtonV2 } from '@fragment/ui/src/components/Button/SecondaryButtonV2/SecondaryButtonV2';
import { TextInput } from '@fragment/ui/src/components/Input/TextInput';
import { Toggle } from '@fragment/ui/src/components/Toggle/Toggle';

export const PersonRow = ({
  name,
  email,
  onSubmit,
}: {
  name?: string;
  email?: string;
  onSubmit?: (name: string, email: string) => void;
}) => {
  const [isLeader, setIsLeader] = useState(false);
  const [nameState, setNameState] = useState(name || '');
  const [emailState, setEmailState] = useState(email || '');
  return (
    <div className="flex flex-col p-f1 w-full gap-y-f1 border-[0.5px] border-main-300">
      <div className="flex flex-row gap-x-f2 w-full">
        <TextInput
          padding="p-f0"
          label="Name"
          size="md"
          value={nameState}
          onChange={(e) => setNameState(e.target.value)}
        />
        <TextInput
          padding="p-f0"
          label="Email"
          size="md"
          value={emailState}
          onChange={(e) => setEmailState(e.target.value)}
        />
      </div>
      {onSubmit && (
        <div className="flex flex-row justify-between w-full">
          <Toggle
            controlled
            activeButton={isLeader ? 'left' : 'right'}
            leftLabel="Leader"
            rightLabel="Owner"
            onLeftClick={() => setIsLeader(true)}
            onRightClick={() => setIsLeader(false)}
            buttonHeight="h-f2"
            buttonPadding="px-f0"
          />
          <SecondaryButtonV2
            className="w-fit h-fit"
            onClick={() => onSubmit(nameState, emailState)}
            disabled={
              nameState.trim().length === 0 || emailState.trim().length === 0
            }
          >
            Submit
          </SecondaryButtonV2>
        </div>
      )}
    </div>
  );
};

type PeopleViewProps = {
  onNext?: () => void;
};

export const PeopleView = ({ onNext }: PeopleViewProps) => {
  const [people, setPeople] = useState<{ name: string; email: string }[]>([]);
  return (
    <div className="flex flex-col h-fit gap-y-f2">
      <span className="text-main">
        Invite key individuals to complete their onboarding.
      </span>
      <span className="text-main">
        Invite someone in a significant leadership role at your company, such as
        the CEO, CFO, or other executive.
      </span>
      <span className="text-main">
        Invite every person who owns more than a 25% stake in the company.
      </span>

      {people.map((person) => (
        <PersonRow key={person.email} name={person.name} email={person.email} />
      ))}
      <span>Invite</span>
      <PersonRow
        onSubmit={() => setPeople([...people, { name: 'test', email: 'test' }])}
      />
      {onNext != null && (
        <PrimaryButtonV2 onClick={onNext}>Next</PrimaryButtonV2>
      )}
    </div>
  );
};
